export const logToConsole = (type = "log", ...options) => {
  // eslint-disable-next-line no-console
  if (type === "log") console.log(...options)
  if (type === "error") console.error(...options)
  if (type === "warn") console.warn(...options)
}
